import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { AuthGuard, CmsConfig, ConfigModule, I18nModule, RoutingConfig, UrlModule } from '@spartacus/core';
import { CmsPageGuard, FormErrorsModule, PageLayoutComponent } from '@spartacus/storefront';

// import { KnBrCustomerContextGuard } from './../../shared/guards/kn-br-customer-context.guard';
import { KnBrCustomerContextGuard } from 'src/shared/guards/kn-br-customer-context.guard';
import { KnBrMyQuoteCreateComponent } from './kn-br-my-quote-create.component';

@NgModule({
  declarations: [KnBrMyQuoteCreateComponent],
  imports: [
    CommonModule,
    I18nModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    UrlModule,
    FormErrorsModule,
    NgSelectModule,
    ConfigModule.withConfig({
      cmsComponents: {
        KnBrStep2CustomerQuoteCreateComponent: {
          component: () => import('./kn-br-my-quote-create.component').then((c) => c.KnBrMyQuoteCreateComponent),
          guards: [KnBrCustomerContextGuard],
        },
      },
    } as CmsConfig),
    RouterModule.forChild([
      {
        data: { pageLabel: '/step2-create-quote', cxRoute: 'step2CustomerCreateQuote' },
        path: null,
        canActivate: [AuthGuard, CmsPageGuard],
        component: PageLayoutComponent,
      },
    ]),
    ConfigModule.withConfig({
      routing: {
        routes: {
          step2CustomerQuoteCreate: {
            paths: ['step2-create-quote'],
          },
        },
      },
    } as RoutingConfig),
  ],
  exports: [KnBrMyQuoteCreateComponent],
})
export class KnBrMyQuoteCreateModule { }
